// Guard against a dangerous URL scheme (javascript:, data:, etc.) reaching
// an <a href> — sourceUrl on an idea can originate from user-pasted links,
// AI extraction results, or a shared payload from another app (ShareInboxScreen),
// none of which should be trusted to have a safe scheme by construction.
// Every render site that turns a sourceUrl into a clickable link should gate
// on this rather than re-deriving its own check.
export function isSafeHttpUrl(url) {
  if (!url) return false;
  try { return /^https?:$/i.test(new URL(url).protocol); } catch { return false; }
}
